module.exports = __webpack_public_path__ + "img/welcome4.40821f78.jpg";